<div class="package-card-grid" *ngIf="package">
  <div
    class="card-header-grid"
    [class.card-header-grid--light]="isLightThemeHeader"
    [style.background]="package.theme_color | themeBackground"
  >
    <div
      class="status-indicator-grid"
      [style.background]="package.package_status ? '#22C55E' : '#EF4444'"
    >
      <span class="status-text-grid">{{ package.status_str }}</span>
    </div>
    <div class="package-title-grid">{{ package.package_name }}</div>
    <div class="package-subtitle-grid">
      created {{ package.created_at | date: 'dd.MM.yy' }}, last configured
      {{ package.updated_at | date: 'dd.MM.yy' }}
    </div>
  </div>
  <div class="card-tabs-grid" *ngIf="shouldShowTabs() || package.type === 'detailing'">
    <div
      class="tab-grid"
      *ngIf="shouldShowSingleTab()"
      [ngClass]="{ 'active-tab-grid': activeTab === 'single' }"
      (click)="switchTab('single')"
    >
      Single
    </div>
    <div
      class="tab-grid"
      *ngIf="shouldShowSubscriptionTab()"
      [ngClass]="{ 'active-tab-grid': activeTab === 'subscription' }"
      (click)="switchTab('subscription')"
    >
      Unlimited
    </div>
    <div class="tab-grid active-tab-grid" *ngIf="package.type === 'detailing'">Detailing</div>
  </div>
  <div class="card-content-grid">
    <div class="price-section-grid">
      <div class="price-columns-container">
        <div class="price-column-grid">
          <div class="price-title-grid">{{ getPriceLabel() }}</div>
          <div class="price-values-grid">
            <span class="current-price-grid">{{ getCurrentPrice() | currency }}</span>
            <span class="original-price-grid" *ngIf="getStrikeoffPrice() as strikeoffPrice">{{
              strikeoffPrice | currency
            }}</span>
          </div>
        </div>
      </div>
      <div class="price-note-grid" *ngIf="package.license_plate_needed">
        *License plate required for this wash.
      </div>
    </div>

    <div class="details-section-grid" *ngIf="!isAddOnPackage() && hasFeatures">
      <app-package-grid-card-features
        [features]="displayedFeatures"
        [hasHiddenFeatures]="hasHiddenFeatures"
        [toggleLabel]="featuresToggleLabel"
        (toggle)="toggleFeaturesVisibility()"
      ></app-package-grid-card-features>
    </div>

    <!-- Select Package Button -->
    <div class="select-package-section">
      <button class="select-package-btn" (click)="onSelectPackage()">Select Package</button>
    </div>
  </div>
</div>
